const investorCompanyTypes = [
  {
    id: 'ICT00',
    title: 'Banco Online Fintech',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    id: 'ICT01',
    title: 'Banco Internacional',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    id: 'ICT02',
    title: 'Banco Nacional',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    id: 'ICT03',
    title: 'Cooperativa de Crédito Internacional',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    id: 'ICT04',
    title: 'Cooperativa de Crédito Nacional',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    id: 'ICT05',
    title: 'Banco de Desarrollo Internacional',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    id: 'ICT06',
    title: 'Banca de Inversión Internacional',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    id: 'ICT07',
    title: 'Venture Capital',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    id: 'ICT08',
    title: 'Private Equity',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    id: 'ICT09',
    title: 'Boutique de Inversión',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    id: 'ICT10',
    title: 'Institución Deuda Privada Corporativa',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    id: 'ICT11',
    title: 'Institución Financiación Pública',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    id: 'ICT12',
    title: 'Capital de Trabajo/Working Capital',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    id: 'ICT13',
    title:
      'Institución Activos de Lessor/Leasing/Leaseback/Renback/Renting/Etc.',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    id: 'ICT14',
    title:
      'Institución Aseguradoras/Caución/Garantías Fianzas Avales Corporativas.',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    id: 'ICT15',
    title: 'Aceleradoras de Start Up, Empresas...',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    id: 'ICT16',
    title: 'Plataformas de Recaudación Crowdfunding',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    id: 'ICT20',
    title: 'Institución Financiera Privada.',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    id: 'ICT21',
    title: 'Institución Financiera Fomentar Exportación Pública.',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    id: 'ICT22',
    title: 'Banco Ético Internacionales.',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    id: 'ICT23',
    title: 'Inversores Privados, Mentores, Family Office, SICAV, Etc.',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    id: 'ICT26',
    title: 'International comercial bank',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    id: 'ICT27',
    title: 'International and institutional business',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    id: 'ICT25',
    title: 'Negocios internacionales e institucionales',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    id: 'ICT28',
    title:
      'Instistutions and plateform of cryptocurrencies,cryptoasset and digital currency',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    id: 'ICT29',
    title: 'Institutions for Islamic financial',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    id: 'ICT30',
    title: 'International Development Islamic Bank',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    id: 'ICT31',
    title: 'Institución de desarrollo privada',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    id: 'ICT32',
    title: 'Institución de inversión privada',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    id: 'ICT33',
    title: 'Plataforma de tokenización/plataforma de distribución y marketing de tokens',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    id: 'ICT24',
    title: 'OTROS',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  }
]
export default investorCompanyTypes
